import { render, staticRenderFns } from "./productspecDetails.vue?vue&type=template&id=c9080e78"
import script from "./productspecDetails.vue?vue&type=script&lang=js"
export * from "./productspecDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports